(() => {
  const modal = document.getElementById("neb-quickview-modal");
  const overlay = document.getElementById("neb-quickview-overlay");
  const content = modal?.querySelector(".neb-qv-content");
  const closeBtn = modal?.querySelector(".neb-qv-close");

  if (!modal || !overlay || !content) return;

  const openModal = () => {
    overlay.hidden = false;
    modal.hidden = false;
    document.documentElement.classList.add("neb-qv-open");
    closeBtn?.focus();
  };

  const closeModal = () => {
    modal.hidden = true;
    overlay.hidden = true;
    content.innerHTML = "";
    document.documentElement.classList.remove("neb-qv-open");
  };

  overlay.addEventListener("click", closeModal);
  closeBtn?.addEventListener("click", closeModal);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !modal.hidden) closeModal();
  });

  async function loadQuickView(handle) {
    // Render ONLY the quickview section from the product page
    const url = `/products/${handle}?section_id=neb-quickview`;

    content.innerHTML = `<div class="neb-qv-loading">Loading…</div>`;
    openModal();

    const res = await fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } });
    const html = await res.text();

    // Inject returned section HTML
    content.innerHTML = html;

    // IMPORTANT: re-init Shopify/dawn components if needed
    // If you use variant pickers / quantity / add-to-cart JS:
    document.dispatchEvent(new Event("neb:quickview:loaded"));
  }

  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".neb-quickview-btn");
    if (!btn) return;

    const handle = btn.getAttribute("data-product-handle");
    if (!handle) return;

    e.preventDefault();
    loadQuickView(handle).catch(() => {
      content.innerHTML = `<div class="neb-qv-error">Couldn’t load product.</div>`;
    });
  });
})();